import { NgModule } from '@angular/core';

import { ApiService }          from './api.service';
import { CacheService }        from './cache.service';
import { StreamSearchService } from './stream-search.service';
import { WebsocketsModule }    from './websockets/websockets.module';

@NgModule({
  providers: [
    ApiService,
    CacheService,
    StreamSearchService
  ],
  imports: [
    WebsocketsModule
  ]
})
export class ApiModule {}
